import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=1841ac4e&scoped=true"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"
import style0 from "./Matches.vue?vue&type=style&index=0&id=1841ac4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841ac4e",
  null
  
)

export default component.exports